<script setup lang="ts">
const props = defineProps({
  rotate: {
    type: Boolean,
    required: false,
    default: false,
  },
  vertical: {
    type: Boolean,
    required: false,
    default: false,
  },
  thin: {
    type: Boolean,
    required: false,
    default: false,
  },
  color: {
    type: String,
    required: false,
    default: "fill-white",
  },
  hover: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const position = computed(() => {
  if (!props.vertical) {
    return props.rotate ? "rotate-90" : "-rotate-90";
  } else {
    return props.rotate ? "rotate-180" : "";
  }
});
</script>

<template>
  <svg
    v-if="thin"
    viewBox="0 0 48 48"
    width="48"
    height="48"
    xmlns="http://www.w3.org/2000/svg"
    class="cursor-pointer transition-all duration-300 ease-in-out"
    :class="[
      position,
      color,
      { 'hover:fill-primary-500 group-hover:fill-primary-500': hover },
    ]">
    <g id="Keyboard arrow down">
      <path
        id="Vector"
        d="M34 14.82L24.84 24L34 33.18L31.18 36L19.18 24L31.18 12L34 14.82Z" />
    </g>
  </svg>
  <svg
    v-else
    viewBox="0 0 12 8"
    width="12"
    height="8"
    class="cursor-pointer transition-all duration-300 ease-in-out"
    xmlns="http://www.w3.org/2000/svg"
    :class="[
      position,
      color,
      { 'hover:fill-primary-500 group-hover:fill-primary-500': hover },
    ]">
    <path
      d="M5.36605 7.48546L0.264458 2.38387C-0.0881526 2.03126 -0.0881526 1.46108 0.264458 1.11222L1.11222 0.264458C1.46483 -0.0881526 2.03501 -0.0881526 2.38387 0.264458L6 3.88059L9.61613 0.264458C9.96874 -0.0881526 10.5389 -0.0881526 10.8878 0.264458L11.7355 1.11222C12.0882 1.46483 12.0882 2.03501 11.7355 2.38387L6.63395 7.48546C6.28884 7.83807 5.71866 7.83807 5.36605 7.48546Z" />
  </svg>
</template>
